import React from 'react';

import {FlowchartSidepanelManagerContext} from './FlowchartSidepanelUnsavedChangesContext';
import useFlowchartSidepanelManager from './useFlowchartSidepanelManager';

export interface FlowchartSidepanelManagerProps {
  getNodeNameById: (nodeId: string) => string | null;
  /** The flowchart type name for analytics tracking. */
  flowchartType: string;
  children: React.ReactNode;
}

/**
 * Manages the sidepanel state for the flowchart config editor.
 *
 * Convenience wrapper around useFlowchartSidepanelManager to provide the context value to the children.
 *
 * @param props.getNodeNameById - A function to get a flowchart node name by its ID (used for modal display).
 * @param props.flowchartType - The flowchart type name for analytics tracking.
 * @param props.children - The children to render.
 */
export default function FlowchartSidepanelManager(props: FlowchartSidepanelManagerProps): JSX.Element {
  const sidepanelManager = useFlowchartSidepanelManager({
    getNodeNameById: props.getNodeNameById,
    flowchartType: props.flowchartType,
  });
  const sidepanelManagerContextValue = React.useMemo(() => sidepanelManager, [sidepanelManager]);

  return (
    <FlowchartSidepanelManagerContext.Provider value={sidepanelManagerContextValue}>
      {props.children}
    </FlowchartSidepanelManagerContext.Provider>
  );
}
